import { connect } from 'react-redux'
import { TurnSelectMenu } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { puzzleInfo } = state.renjuBoardCards.cards[ownProps.bid]
  var selectedTurn
  selectedTurn = puzzleInfo ? puzzleInfo.selectedTurn : undefined
  return ({
    selectedTurn
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleChange: (event) => {
      ownProps.onChange(ownProps.bid, event.target.value)
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TurnSelectMenu)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/TurnSelectMenu.js